'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M722.744 365.256l82.746 82.744h-586.98l82.746-82.744c12.496-12.498 18.744-28.878 18.744-45.256s-6.248-32.758-18.746-45.256c-24.994-24.992-65.516-24.992-90.51 0l-192 192c-24.994 24.996-24.994 65.518 0 90.51l192 192c24.994 24.994 65.516 24.994 90.51 0 24.994-24.992 24.994-65.516 0-90.508l-82.744-82.746h586.98l-82.746 82.744c-24.992 24.994-24.992 65.516 0 90.51 24.994 24.994 65.518 24.994 90.512 0l192-192c12.496-12.496 18.744-28.876 18.744-45.254s-6.248-32.758-18.744-45.256l-192-192c-24.994-24.992-65.518-24.992-90.512 0-24.992 24.996-24.992 65.516 0 90.512z' })
    ));
};